<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="mint-box">
        <div class="title lo">
          <span v-html="$t('mintpage.text11')"></span>
        </div>
        <div class="nfts">
          <div class="item">
            <div
              class="img1"
              :style="{
                backgroundImage: 'url(' + $store.state.imgUrl + image + ')'
              }"></div>
          </div>
        </div>
        <div class="share-box">
          <div class="title">{{ $t('share') }}</div>
          <CopyBox :copyText="sharePath" style="margin-bottom: 0.3rem" />
          <ShareBox :sharePath="sharePath" />
        </div>
        <div class="btns2">
          <el-button
            class="el-button--special2 round block"
            @click="handleMint"
            >{{ $t('mintpage.text12') }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postNftInfo } from '@/api/user'
import CopyBox from '@/components/CopyBox.vue'
import ShareBox from '@/components/ShareBox.vue'

export default {
  name: 'MintSuccess',
  components: { ShareBox, CopyBox },
  data() {
    return {
      image: '',
      sharePath: ''
    }
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.nftImg = this.$route.params.nftImg
  },
  methods: {
    init() {
      let params = {
        rec_code: this.$route.query.rec_code
      }
      postNftInfo(params).then((res) => {
        this.image = res.data.image
      })
      this.sharePath =
        this.$store.state.userPath +
        '/user/nftdetail?inviteCode=' +
        this.$store.state.user_info.rec_code +
        '&inviteNft=' +
        this.$route.query.rec_code +
        '&rec_code=' +
        this.$route.query.rec_code
    },
    handleMint() {
      this.handleRoute('/babe/hotnft')
    },
    handleRoute(path) {
      this.$router.push({
        path: path,
        query: { rec_code: this.$route.query.rec_code }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.des {
  position: fixed;
  bottom: 1.4rem;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.12rem;
}
.btns {
  .el-button {
    width: 1.58rem;
    height: 0.48rem;
    line-height: 0.48rem;
  }
}
.nfts {
  display: flex;
  justify-content: center;
  .item {
    margin: 0 0.09rem;
  }
  .tit {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.16rem;
    margin-bottom: 0.25rem;
  }
  .img1 {
    width: 2.18rem;
    height: 2.98rem;
    background-size: cover;
  }
  .advanced {
    .img-box2 {
      position: relative;
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: -0.04rem;
        top: -0.04rem;
        bottom: -0.04rem;
        right: -0.04rem;
        background-image: linear-gradient(
          to right bottom,
          #ac7829,
          #b07d30,
          #ffe1b4,
          #c89b59
        );
        z-index: -1;
      }
    }
  }
  .price {
    font-weight: bold;
    font-size: 0.14rem;
    .unit {
      color: rgba(255, 255, 255, 0.5);
      margin-left: 0.07rem;
    }
  }
}
.share-box {
  .title {
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.12rem;
  }
  .cont {
    display: flex;
    justify-content: center;
    .icon {
      width: 0.24rem;
      height: 0.24rem;
      background-repeat: no-repeat;
      background-size: 0.24rem;
      background-position: center center;
      margin: 0 0.14rem;
      &.photo {
        background-image: url('~@/assets/images/photo.svg');
      }
      &.twitter {
        background-image: url('~@/assets/images/twitter.svg');
      }
      &.facebook {
        background-image: url('~@/assets/images/facebook.svg');
      }
    }
  }
}
.mint-box {
  .img-box2 {
    margin-bottom: 0.18rem;
  }
}
.btns2 {
  padding: 0.15rem 0.74rem;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/babe/mintsuccess.vue